import $ from 'jquery';
import moment from 'moment';
import { renderEdit } from './form';

export const create = () => {
  bindForm();
};

export const edit = ctx => {
  bindForm();

  const id = ctx.params.id;
  if (id && !Number.isNaN(parseInt(id, 10))) {
    // Bind form handling
    renderEdit(id);
  }
};

function bindForm() {
  $('.ui.calendar').calendarFr({
    type: 'date',
    parser: {
      date: (text, settings) => moment(text, 'DD/MM/YYYY').toDate(),
    },
    formatter: {
      datetime: date => {
        if (!date) {
          return '';
        }

        return moment(date).format('DD/MM/YYYY');
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/modules/survey/index.js